import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { toResponseError, type UserTokenAddInput, type UserTokenAddSuccess, type UserTokenId } from '@terros/common'

export function useAddUserToken(): AddHookResponse<void, UserTokenId> {
  const mutation = useTantalimMutation<UserTokenAddInput, UserTokenAddSuccess>({ url: '/user/token/add' })

  async function add(): Promise<UserTokenId> {
    try {
      const res = await mutation.mutateAsync({})
      return res.userToken
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
